import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import { getAccessToken, redirectUserToPdP } from './auth-token';

export type CreateAxiosApiProps = {
  baseURL: string;
  headers?: AxiosRequestHeaders;
};

export const createAxiosApi = ({ baseURL, headers }: CreateAxiosApiProps): AxiosInstance => {
  const axiosApi = axios.create({
    baseURL,
    headers,
  });

  axiosApi.interceptors.request.use(
    async (response: any) => {
      const token = await getAccessToken();

      if (token) {
        response.headers.Authorization = token ? `Bearer ${token}` : '';
        return response;
      }

      redirectUserToPdP();
    },
    (error) => {
      console.log('request error', error);
      return Promise.reject(error);
    },
  );

  axiosApi.interceptors.response.use(
    (response) => response,
    (error: any) => {
      if (
        error.response != null &&
        (error.response.status === 403 || error.response.status === 401)
      ) {
        console.log('failed to fetch api', error);
        redirectUserToPdP();
      }
    },
  );

  return axiosApi;
};
